import { routeGroup } from '#/routing/routes';

export const postSearchRouteReference = routeGroup.route(':slug', ['pq']);
